// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"101":"c64a8876","499":"14978bb2","514":"55865289","818":"965b2aa3"}[chunkId] + ".chunk.css";
};